import {parseDate as parseArkDate} from '@ark-ui/react/date-picker'
import moment from 'moment'

export const FALLBACK_DATE_LOCALE = 'nl-NL'
export const ACCEPTED_INPUT_DATE_FORMATS = ['DD-MM-YYYY', 'YYYY-MM-DD']
export const DISPLAYED_DATE_FORMAT = 'DD-MM-YYYY'
export const ARK_DATE_FORMAT = 'YYYY-MM-DD'

export const fromArkDateValues = values => {
	return values.filter(Boolean).map(value => moment(value.toString(), ARK_DATE_FORMAT, true))
}

/** @param {import('moment').Moment | undefined} value */
export const toArkDateValue = value => {
	if (!value) return value

	return value.isValid() ? parseArkDate(value.format(ARK_DATE_FORMAT)) : undefined
}

/** @param {import('moment').Moment[] | null} values */
export const toArkDateValues = values => {
	if (!values) return []
	if (values.length === 0) return []

	return values.map(toArkDateValue)
}

/**
 * @typedef {Object} SingleDatePickerContextValues
 * @property {import('moment').Moment | undefined} value
 * @property {(value: import('moment').Moment | undefined) => void} setValue
 * @property {() => void} clear
 * @property {(state: boolean) => void} setOpen
 * @property {boolean} open
 */

/**
 * @typedef {Object} MultipleDatePickerContextValues
 * @property {import('moment').Moment[]} value
 * @property {(value: import('moment').Moment[]) => void} setValue
 * @property {() => void} clear
 * @property {(state: boolean) => void} setOpen
 * @property {boolean} open
 */
/** @typedef {SingleDatePickerContextValues | MultipleDatePickerContextValues} DatePickerContextValues */

/**
 * @param {import('@ark-ui/react/date-picker').UseDatePickerContext} ctx
 * @returns {DatePickerContextValues}
 */
export const fromArkDatePickerContextValues = ctx => {
	if (ctx.selectionMode === 'single')
		return {
			value: fromArkDateValues(ctx.value)[0],
			setValue: value => ctx.setValue(toArkDateValues(value ? [value] : [])),
			clear: () => ctx.clearValue(),
			setOpen: state => ctx.setOpen(state),
			open: ctx.open,
		}

	return {
		value: fromArkDateValues(ctx.value),
		setValue: value => ctx.setValue(toArkDateValues(value)),
		clear: () => ctx.clearValue(),
		setOpen: state => ctx.setOpen(state),
		open: ctx.open,
	}
}
